import axios from "axios";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { showToast } from "../../CoreDataService";
import OptionOrderBook from "./OptionOrderBook";
import { OptionDataContenxt } from "./OptionChartDashboard";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import { useTradingColors } from "../Spot/tradingColorConfig";

const OptionLeftTable = () => {
  const {
    setCurrencycode,
    setBasecurrency,
    setAssetPair,
    assetpair,
    setAssetPairName,
    setDerivativeAssets,
  } = useContext(OptionDataContenxt);
  const { brokerBasicInfo, btncolor } = useSelector((state) => state);
  const { pairButtonColor, upColor, downColor } = useTradingColors();
  const theme = localStorage.getItem("theme");
  const [show, setShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState("");
  const [currency, setCurrency] = useState("BTC");
  const [filterCurrency, setFilterCurrency] = useState([]);
  const [dropdownFiatList, setDropdownFiatList] = useState([]);
  const [assetetpair, setAssetetpair] = useState([]);
  const [assetetpairback, setAssetetpairback] = useState([]);
  const [assetetpairbackOrigin, setAssetetpairbackOriginal] = useState([]);
  const [roccolor, setRoccolor] = useState(false);
  const [ltpcolor, setLtpcolor] = useState(null);
  const [sort, setSort] = useState(false);
  const [showFiat, setShowFiat] = useState(false);
  const [fiatSelected, setFiatSelected] = useState("FIAT");
  const [filteredAssetPairs, setFilteredAssetPairs] = useState([]);
  const [header, setHeader] = useState([]);

  const [amountPrecision, setAmountPrecision] = useState(0);
  const [pricePrecision, setPricePrecision] = useState(0);
  const [assetCode, setAssetCode] = useState("");
  const [currencyId, setCurrencyId] = useState("");

  const handleClose = () => setShow(false);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  const handleSelect = (data) => {
    setSelected(data);
    setIsOpen(!isOpen);
  };

  // useEffect(() => {
  //   const storedTradeP = localStorage.getItem("tradep");
  //   if (storedTradeP) {
  //     setTradep(parseInt(storedTradeP));
  //   }
  // }, []);

  useEffect(() => {
    setSelected(assetpair);
    if (assetpair && typeof assetpair === "string") {
      setCurrencycode(assetpair.split("-")[0]);
    } else {
      setCurrencycode("BTC");
    }
    getNewCurrency();
  }, []);

  const getNewCurrency = async (currency = "ALL") => {
    setCurrency(currency);
    try {
      const response = await axios.get(
        `https://accounts.paybito.com/CacheService/api/getData?Name=OptionsAssets`
      );
      const data = JSON.parse(response.data.value);
      setHeader(data.Header);
      localStorage.setItem("options_assets", response.data.value);
      setDerivativeAssets(data.Values);
      const assets = data.Values;
      console.log("assets", assets);
      const basecur = assets.find(
        (x) => x.baseCurrency === "USDT" && x.currencyCode === "BTC"
      );

      if (basecur?.length !== 0) {
        localStorage.setItem("amountprc", basecur.amountPrecision);
        localStorage.setItem("priceprc", basecur.pricePrecision);
        localStorage.setItem("assetCode", basecur.assetCode);
      }

      let filteredAssets = assets.filter(
        (x) => x.contractValue === currency || currency === "ALL"
      );

      if (filteredAssets?.length === 0) {
        showToast(
          "error",
          "Currently there are no contracts to display in Options market. Please check back later."
        );
      }

      setAssetetpairback(
        filteredAssets.map((asset) => ({
          currencycode: asset.currencyCode,
          basecurrency: asset.baseCurrency,
          lastTrade1: asset.ltpValue,
          lastTrade2: asset.ltpConvValue,
          lPriceColor:
            asset.action === "buy"
              ? true
              : asset.action === "sell"
              ? false
              : null,
          roc: asset.roc,
          volume: asset.volume,
          rocColor: asset.roc > 0,
          amountPrecision: asset.amountPrecision,
          pricePrecision: asset.pricePrecision,
          assetCode: asset.assetCode,
          assetPair: asset.assetPair,
          assetPairName: asset.assetPairName,
          currencyId: asset.currencyId,
        }))
      );
      setAssetetpairbackOriginal(
        filteredAssets.map((asset) => ({
          currencycode: asset.currencyCode,
          basecurrency: asset.baseCurrency,
          lastTrade1: asset.ltpValue,
          lastTrade2: asset.ltpConvValue,
          lPriceColor:
            asset.action === "buy"
              ? true
              : asset.action === "sell"
              ? false
              : null,
          roc: asset.roc,
          volume: asset.volume,
          rocColor: asset.roc > 0,
          amountPrecision: asset.amountPrecision,
          pricePrecision: asset.pricePrecision,
          assetCode: asset.assetCode,
          assetPair: asset.assetPair,
          assetPairName: asset.assetPairName,
          currencyId: asset.currencyId,
        }))
      );

      // changeDetectorRef.detectChanges();
    } catch (error) {
      console.error("Error fetching asset data", error);
    }
  };
  const handleCurrencySelect = (d) => {
    console.log("assetdatatata", d);
    setSelected(d?.assetPairName);
    setAssetPair(d?.assetPair);
    setCurrencycode(d?.currencycode);
    setBasecurrency(d?.basecurrency);
    localStorage.setItem("buying_crypto_asset_options", d?.currencycode);
    localStorage.setItem("selling_crypto_asset_options", d?.basecurrency);
    setIsOpen(false);
  };

  const handleSearch = (searchText) => {
    if (searchText !== "") {
      const filterData = assetetpairbackOrigin?.filter((data) =>
        data?.assetPairName.includes(searchText.toUpperCase())
      );
      setAssetetpairback(filterData);
    } else {
      setAssetetpairback(assetetpairbackOrigin);
    }
  };

  const handleVolumnToggle = () => {
    if (sort) {
      const sortData = assetetpairback.sort((a, b) => a?.volume - b?.volume);
      setAssetetpairback(sortData);
      setSort(false);
    } else {
      const sortData = assetetpairback.sort((a, b) => b?.volume - a?.volume);
      setAssetetpairback(sortData);
      setSort(true);
    }
  };
  const handleSelectFiat = (text) => {
    setFiatSelected(text);
    setShowFiat(false);
  };

  const websocket = {
    stompClient: null,
    unsubscribe: () => console.log("Unsubscribed"),
    _disconnect: () => console.log("WebSocket Disconnected"),
    _connect: () => console.log("WebSocket Connected"),
    subscribe: () => console.log("WebSocket Subscribed"),
  };

  const trade = {
    reload: () => console.log("Trade reloaded"),
    myTradeDisplay: (value) => console.log("My Trade Display: ", value),
  };

  const callTradeHistory = (action) =>
    console.log("Trade History called with action: ", action);

  const setTradeData = (updateFunction) =>
    console.log("Trade Data Updated", updateFunction);

  const buySellCode = (item) => {
    console.log("items<<<", item);
    websocket.unsubscribe();

    if (websocket.stompClient !== null) {
      setTimeout(() => {
        websocket.subscribe();
      }, 5000);
    }

    // if (websocket?.tickerSubscription) {
    //   websocket?.tickerSubscription?.unsubscribe();
    // }
    // if (websocket?.subscription) {
    //   websocket?.subscription?.unsubscribe();
    // }
    // if (websocket?.subscription1) {
    //   websocket?.subscription1?.unsubscribe();
    // }

    // resetStopLossInputField();

    setCurrencycode(item.currency === "BCC" ? "BCH" : item.currencycode);
    setBasecurrency(item.basecurrency);
    setAssetPair(item.assetPair);
    setAssetPairName(item.assetPairName);
    setAmountPrecision(item.amountPrecision);
    setPricePrecision(item.pricePrecision);
    setAssetCode(item.assetCode);
    setCurrencyId(item.currencyId);

    // document.getElementById("myDropdown")?.classList.toggle("show");

    localStorage.setItem("amountprc", item.amountPrecision);
    localStorage.setItem("priceprc", item.pricePrecision);
    localStorage.setItem("assetCode", item.assetCode);
    localStorage.setItem("currencyId", item.currencyId);
    localStorage.setItem(
      "buying_crypto_asset",
      item.currencycode.toLowerCase()
    );
    localStorage.setItem(
      "selling_crypto_asset",
      item.basecurrency.toLowerCase()
    );
    localStorage.setItem("selected_options_asset_pair", item.assetPair);
    localStorage.setItem(
      "selected_options_asset_pair_name",
      item.assetPairName
    );

    localStorage.setItem("isAssetPairChangedRecentlyOptions", "true");
    localStorage.setItem("isResetTheStoplossfieldForOptions", "true");

    let assetChangeCounter = localStorage.getItem(
      "assetChangeCounterForOptions"
    );
    if (assetChangeCounter) {
      assetChangeCounter = parseInt(assetChangeCounter) + 1;
      localStorage.setItem(
        "assetChangeCounterForOptions",
        assetChangeCounter.toString()
      );
    } else {
      localStorage.setItem("assetChangeCounterForOptions", "1");
    }

    // handleSetLeverageMinMaxValue('2', '125');
  };

  console.log("assetetpairback", assetpair);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        flex: 1,
        minHeight: 0,
        position: "relative",
      }}
    >
      <div
        className="currency_Container"
        style={{
          backgroundColor: pairButtonColor || btncolor,
          flexShrink: 0,
        }}
      >
        <p
          className="currency_text d-flex align-items-center justify-content-center"
          onClick={handleToggle}
        >
          {selected || assetpair}
          {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </p>
      </div>
      {isOpen && (
        <div
          className="dropdown_ derivativeDropdown"
          style={{
            backgroundColor: "var(--body-color)",
          }}
        >
          <div
            className="search_container"
            tabindex="0"
            style={{ margin: "10px" }}
          >
            <i class="fa-solid fa-magnifying-glass"></i>
            <input
              type="text"
              placeholder="Search"
              onChange={(e) => handleSearch(e.target.value)}
            />
          </div>
          <div className="currency_ d-flex ">
            <div>
              {header?.length !== 0 &&
                header?.map((d, i) => (
                  <button
                    key={i}
                    onClick={() => getNewCurrency(d)}
                    style={{
                      cursor: "pointer",
                      margin: "5px",
                      fontSize: "16px",
                      border: "none",
                      backgroundColor: "var(--body-color-less3)",
                      color: "var(--text-color)",
                      padding: "5px 10px",
                      marginLeft: "10px",
                      borderRadius: "5px",
                      boxShadow:
                        "rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px",
                    }}
                  >
                    {d}
                  </button>
                ))}
            </div>
          </div>

          <div
            className="table_content_dropdown"
            style={{ maxHeight: "200px" }}
          >
            <table style={{ marginTop: "7px" }}>
              <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                <th
                  style={{
                    textAlign: "start",
                    backgroundColor: "var(--body-color-less3)",
                    color: "var(--text-color)",
                  }}
                >
                  Pair
                </th>
                <th
                  style={{
                    backgroundColor: "var(--body-color-less3)",
                    color: "var(--text-color)",
                    textAlign: "end",
                  }}
                >
                  Last Price
                </th>
                <th
                  style={{
                    backgroundColor: "var(--body-color-less3)",
                    color: "var(--text-color)",
                    textAlign: "end",
                  }}
                >
                  ROC
                </th>
                <th
                  style={{
                    cursor: "pointer",
                    backgroundColor: "var(--body-color-less3)",
                    color: "var(--text-color)",
                    textAlign: "end",
                  }}
                  onClick={handleVolumnToggle}
                >
                  <ImportExportIcon sx={{ fontSize: "16px" }} /> Volume
                </th>
              </thead>
              <tbody style={{ overflowY: "scroll" }}>
                {assetetpairback?.length !== 0 &&
                  assetetpairback?.map((d, i) => (
                    <tr
                      key={i}
                      onClick={() => buySellCode(d)}
                      style={{ cursor: "pointer" }}
                    >
                      <td
                        style={{
                          fontWeight: "bold",
                          cursor: "pointer",
                          textAlign: "start",
                          color: theme === "light" ? "rgb(0, 123, 255)" : "",
                        }}
                        onClick={() => handleCurrencySelect(d)}
                      >
                        <img
                          src={`https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/${d?.currencycode}.png`}
                          alt="vtho"
                          style={{
                            height: "14px",
                            width: "14px",
                            marginRight: "3px",
                          }}
                        />
                        {d?.assetPairName}
                      </td>
                      <td
                        className={`${
                          theme === "dark" ? "text-white" : "text-dark"
                        } asset-dtl-font text-right`}
                        style={{ fontSize: "16px", textAlign: "end" }}
                      >
                        <span
                          style={{
                            color:
                              d?.lPriceColor == null
                                ? theme === "dark"
                                  ? "beige"
                                  : "black"
                                : d?.lPriceColor
                                ? upColor
                                : downColor,
                          }}
                        >
                          {d?.lastTrade1}
                        </span>
                        <span
                          style={{
                            color: "rgb(161, 161, 159)",
                            fontSize: "10px",
                          }}
                        >
                          {" "}
                          /{" "}
                        </span>
                        <span style={{ color: "rgb(161, 161, 159)" }}>
                          {d?.basecurrency === "INR" && "₹"}
                          {["USD", "USDT"].includes(d?.basecurrency) && "$"}
                          {d?.basecurrency === "AED" && "د.إ"}
                        </span>
                        <span style={{ color: "rgb(161, 161, 159)" }}>
                          {d?.lastTrade2}
                        </span>
                      </td>
                      <td
                        style={{
                          color: d?.rocColor
                            ? upColor
                            : downColor,
                          textAlign: "end",
                        }}
                      >
                        {(d?.roc).toFixed(2)}
                      </td>
                      <td
                        style={{
                          textAlign: "end",
                          color: theme === "light" ? "black" : "",
                        }}
                      >
                        {d?.volume}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div
        style={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          flexDirection: "column",
          overflow: "hidden",
        }}
      >
        <OptionOrderBook />
      </div>
    </div>
  );
};

export default OptionLeftTable;
